// This file was generated by lezer-generator. You probably shouldn't edit it.
import {LRParser} from "@lezer/lr"
import {locale_tokenizer} from "./locale-tokenizer.ts"
export const parser = LRParser.deserialize({
  version: 14,
  states: "nQQOPOOOOOP'#Cf'#CfOOOP'#Cd'#CdQQOPOOOOOP-E6b-E6b",
  stateData: "f~OPPOQPORPOSPOTPOUPO~O",
  goto: "fZPPPPPPPP[PbQRORSRTQOR",
  nodeNames: "⚠ BackgroundModifier Modifier StackModifier Keyword NotText BackgroundKeyword Stack",
  maxTerm: 10,
  skippedNodes: [0],
  repeatNodeCount: 1,
  tokenData: "RORO",
  tokenizers: [locale_tokenizer],
  topRules: {"Stack":[0,7]},
  tokenPrec: 0
})
